export * from './videoDuration.component';
export const VideoDurationTemplate = require('./videoDuration.html');
